<template>
    <div name="v-popover">
        <v-popover>
            <a>?</a>
            <template slot="popover">
                <slot name="content"/>
            </template>
        </v-popover>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    name: 'helpPopover',
    mixins: [
        Default
    ]
};
</script>

<style lang="scss" scoped>
    .wrapper {
        width: 2em;
        height: 2em;

        a {
            font-size: .8em;
            position: relative;
            bottom: 7px;
            margin: 5px;
        }
    }
</style>
